import styled from 'styled-components';

export const InputWrapper = styled.div`
  width: 300px;
  margin-bottom: 20px;
`;

export const ModalButtonWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ListsContainer = styled.div`
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const ListWrapper = styled.div`
  height: 300px;
  width: 200px;
`;

export const LinkButton = styled.button`
  color: blue;
  border: none;
  font-size: 15px;
  margin-left: 10px;
`;

export const List = styled.ul``;
